<script>
export const group = 'Full'
</script>

<script setup>
import { frames } from '../../../utils/frames'
import InformationSurface from './shared/InformationSurface.vue'
import Reveal from './shared/Reveal.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const panelElement = ref(null)
const eyebrowElement = ref(null)
const titleElement = ref(null)
const imageElement = ref(null)

const eyebrow = computed(() => item.properties.superTitle || 'Update')

onMounted(() => {
  const timeline = gsapTimeline({ name: 'InformationScreenHeadline', delay: frames(10, 50) }).from(panelElement, {
    y: 40,
    opacity: 0,
    duration: frames(24, 50),
    ease: 'power3.out',
  })

  if (imageElement.value) {
    timeline.from(imageElement, { x: -40, opacity: 0, duration: frames(22, 50), ease: 'power3.out' }, 0)
  }

  timeline
    .from(eyebrowElement, { y: 56, opacity: 0, duration: frames(16, 50), ease: 'power2.out' }, `<${frames(2, 50)}`)
    .from(titleElement, { y: 112, opacity: 0, duration: frames(22, 50), ease: 'power3.out' }, `<${frames(2, 50)}`)
})
</script>

<template>
  <Reveal>
    <InformationSurface>
      <div ref="panelElement" class="h-full flex flex-col justify-center">
        <p ref="eyebrowElement" class="mb-6 font-rift text-7xl font-semibold uppercase tracking-[0.05em] text-q-cr-red-primary">
          {{ eyebrow }}
        </p>

        <div class="absolute left-12 bottom-0 size-12 rounded-full border-3 border-joe-cr-blue-primary/60 bg-joe-cr-blue-primary/35" />
        <div class="absolute right-24 top-1/3 size-14 rounded-full bg-q-cr-red-primary/60" />

        <h1 ref="titleElement" class="font-geomanist font-bold text-[8rem] leading-[0.84] tracking-[.025em] text-white relative z-10">
          {{ item.properties.title }}
        </h1>
      </div>

      <template v-if="item.properties.image" #side>
        <div class="flex h-full items-stretch">
          <div class="size-full overflow-hidden rounded-[3rem] border-3 border-joe-cr-blue-primary/70 bg-[linear-gradient(135deg,rgba(30,100,200,0.3)_0%,rgba(30,100,200,0.15)_100%)]">
            <img ref="imageElement" :src="item.properties.image" class="size-full object-cover" />
          </div>
        </div>
      </template>
    </InformationSurface>
  </Reveal>
</template>
